import { Tag } from '../types';

export const TEMPLATE_QUERY_PARAM = 'template';
export const TEMPLATE_GALLERY_PARAM = 'templateGallery';
export const SPEC_TEMPLATE_QUERY_PARAM = 'specTemplate';

// list of dashboard template ids that are available in the template gallery
// these ids will be used in the url to identify the template
export enum DashboardTemplateIds {
  coreWebVitals = 'web-vitals',
  frustrationSignalsOverview = 'frustration-signals-overview',
  featureEngagement = 'feature-engagement',
  productManager = 'product-manager',
  ordersRevenue = 'orders-revenue',
  uxDesigner = 'ux-designer',
  issueMonitoring = 'issue-monitoring',
  marketing = 'marketing',
  purchaseFlowIssues = 'purchase-flow-issues',
  webCaptureConfigurationGuide = 'web-capture-configuration-guide',
  cannedWelcome = 'welcome',
}

export const CAROUSEL_ITEM_WIDTH = 252;
export const CAROUSEL_ITEM_HEIGHT = 208;
export const CAROUSEL_ITEM_MARGIN = 16;
export const SCROLLBAR_WIDTH = 20;

export const TAG_SUPPORT: Tag = {
  id: 1,
  name: 'Support',
};

export const TAG_PRODUCT_MANAGEMENT: Tag = {
  id: 2,
  name: 'Product Management',
};

export const TAG_UX_DESIGN: Tag = {
  id: 3,
  name: 'UX Design',
};

export const TAG_MARKETING: Tag = {
  id: 4,
  name: 'Marketing',
};

export const TAG_ENGINEERING: Tag = {
  id: 5,
  name: 'Engineering',
};

export const TAG_FIND_SESSIONS: Tag = {
  id: 6,
  name: 'sessions',
};

export const TAG_IDENTIFY_FRICTION: Tag = {
  id: 7,
  name: 'friction',
};

export const TAG_PERFORMANCE: Tag = {
  id: 8,
  name: 'performance',
};

export const TAG_VISUALIZATION: Tag = {
  id: 9,
  name: 'visualization',
};

export const TAG_GROW_REVENUE: Tag = {
  id: 10,
  name: 'Grow Revenue',
};

export const TAG_CONFIGURE_FS: Tag = {
  id: 11,
  name: 'Configure Fullstory',
};
